import React, { useState, useEffect, useContext } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import CircularProgress from '@mui/material/CircularProgress';
import {
  NotificationManager,
} from "react-notifications";
import getAllRecruitmentPartnersAndClients from "../../apis/getAllRecruitmentPartnersAndClients";
/*** components */
import "./TestTakingStyle.css";

/*** apis */

import DefaultOrganization from "./DefaultOrganization";
import TestTakingInterval from "./TestTakingInterval";
import globalConfigurationResponse from "../../apis/globalConfiguration/globalConfiguration";
import updateConfigurationResponse from "../../apis/globalConfiguration/updateGlobalConfiguration";
import { UserTypeContext } from "../../AppRoute";
import DataTable from "../../components/DataTable/DataTable";
import UnauthorizedAccess from "../../components/UnauthorizedAccess/UnauthorizedAccess";
/*** api */

const styleSx = {
  table: {
    minWidth: 650,
  },
  bodyForSupport: {
    padding: "0px 30px!important",
  },
  buttonForSupport: {
    justifyContent: "flex-end !important",
    padding: "25px 30px 30px!important",
  },
  title: {
    padding: "16px 30px!important",
  },
  bodyForShare: {
    padding: "0px 30px!important",
  },
};

const SkillTestConfigaration = ({ idContextTest }) => {
  const { userType } = useContext(UserTypeContext);
  const [isDataLoaded, setisDataLoaded] = useState(false);
  const [globalConfiguration, setglobalConfiguration] = useState([]);
  const [openEditModal, setopenEditModal] = useState(false);
  const [openEditModale, setopenEditModale] = useState(false);
  const [dataForEdit, setdataForEdit] = useState({});
  const [defaultOrganization, setDefaultOrganization] = useState([]);
  const [allOrg, setAllOrg] = useState([]);
  const [atvBtn, setAtvBtn] = useState(false);



  const getAllOrganizations = async () => {

    try {
      const res = await getAllRecruitmentPartnersAndClients();

      setAllOrg(res.data.data);
    } catch (err) {
      console.log(err);
    }

  };

  const getGlobalConfiguration = async () => {

    try {
      const globalConfigResponse = await globalConfigurationResponse();

      setglobalConfiguration(
        globalConfigResponse.data.data.filter((e) => !e.name.includes("Default"))
      );
      const filteredData = globalConfigResponse.data.data.filter((org) =>
        org.name.includes("Default")
      );

      setDefaultOrganization(filteredData);

    } catch (error) {
      console.log(error);
    }

  };
  const openEditModalHandler = (list) => {
    if (list.name === "Skill Test Limit") {
      setopenEditModale(true);
      setdataForEdit(list);
    }
    else {
      setopenEditModal(true);
      setdataForEdit(list);

    }
  };
  const closeEditModalHandler = () => {
    setopenEditModal(false);
    setopenEditModale(false);
  };
  const valueChangeHandler = (value) => {
    setdataForEdit((prev) => ({
      ...prev,
      value: value,
    }));
  };
  const updateConfigarationHandler = async () => {
    setAtvBtn(true);
    try {
      const payload = {
        code: dataForEdit.code,
        data: dataForEdit,
      }

      if (payload.data.value > -1) {
        await updateConfigurationResponse(payload);
        getGlobalConfiguration();
        NotificationManager.success(
          `${dataForEdit.name} updated`,
          "Success",
          10000
        );
        setopenEditModal(false);
        setopenEditModale(false);
        setAtvBtn(false);

      }
      else {
        NotificationManager.error('Value can not be in negative', 'Error', 10000)
        setAtvBtn(false);
      }


    } catch (error) {
      console.log(error);
      setAtvBtn(false);
    }
  };

  useEffect(() => {
    const fetchAllData = async () => {
      try {
        await getGlobalConfiguration();
        await getAllOrganizations();
      } catch (error) {
        setisDataLoaded(true);
      } finally {
        setisDataLoaded(true);
      }
    }
    fetchAllData();

  }, []);



  let columns = [
    {
      accessorKey: "name",
      header: "Name",
      size: 150,
      enableSorting: true,
      enableColumnFilter: true,
      filterFn: 'includesString',
    },
    {
      accessorKey: "value",
      header: "Values",
      size: 150,
      enableSorting: true,
      enableColumnFilter: true,
      filterFn: 'includesString',
    },
    {
      id: "action",
      header: "Action",
      cell: ({ row }) => (
        <>
          <button
            className='editBtn_manageSpoc'
            onClick={() => openEditModalHandler(row.original)}
          >
            Edit
          </button>
        </>
      ),
      size: 80,
      enableSorting: false,
      enableColumnFilter: false,
    },
  ]
  return (
    <div>
          <div className="main_container_global_config">
            {!isDataLoaded ? (
              <div className="row padding_80 text-center">
                <CircularProgress />
              </div>
            ) : (
              <>
                {" "}
                {userType === "Admin" ? (
                  <>
                    <div className="section-wrapper email-configuration-container">
                      <section className="email-configuration-wrapper">
                        <div className="test-result-list">
                          <DefaultOrganization
                            data={defaultOrganization}
                            org={allOrg}
                            isDataLoaded={isDataLoaded}
                          />
                          <h3 className="fs-semi-bold fs-30 f-color mt-15">
                            Global Configuration
                          </h3>
                          <DataTable
                            data={globalConfiguration}
                            columns={columns}
                            isLoading={!isDataLoaded}
                          />
                          <TestTakingInterval
                            org={allOrg}
                            userType={userType}
                            isDataLoaded={isDataLoaded}
                          />
                        </div>
                      </section>
                    </div>
                  </>
                ) : userType === "" ? (
                  <div className="row padding_80 text-center">
                    <p className="fs-semi-bold fs-40 f-color">
                      Loading...
                    </p>
                  </div>
                ) : (
                  <>
                    <UnauthorizedAccess />
                  </>
                )}
              </>
            )}
          </div>
        

      <Dialog
        open={openEditModal}
        onClose={closeEditModalHandler}
        aria-labelledby="form-dialog-title"
        maxWidth="sm"
        fullWidth={true}
      >
        <DialogTitle
          id="form-dialog-title"
          sx={styleSx.title}
          className="admindailog_title_modal_global_config"
        >
          {dataForEdit.name}
        </DialogTitle>

        <DialogContent
          sx={styleSx.bodyForSupport}
          className="responsive_Support"
        >
          <div className="dropdown_width_outer mt_12">
            <div className="select customized-select">
              <legend>Value(Days)</legend>
              <input
                type="number"
                className="text_box_cleartalent custom-text-width-demo-email configaration_input"
                defaultValue={dataForEdit.value}
                min='0'
                onChange={(e) => valueChangeHandler(e.target.value)}

              />
            </div>
          </div>
        </DialogContent>
        <DialogActions sx={styleSx.buttonForSupport} className="buttonForSupport">
          <button
            type="button"
            className="btn5 btn-skill cp"
            onClick={closeEditModalHandler}
          >
            Cancel
          </button>
          <button variant="outlined" className="btn5 btn_primary cp" disabled={atvBtn} onClick={updateConfigarationHandler}>
            <div className="btn_loader">
              Submit
              &nbsp;
              {atvBtn &&
                <div >
                  <CircularProgress size={15} />
                </div>
              }
            </div>
          </button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openEditModale}
        onClose={closeEditModalHandler}
        aria-labelledby="form-dialog-title"
        maxWidth="sm"
        fullWidth={true}
      >
        <DialogTitle
          id="form-dialog-title"
          sx={styleSx.title}
          className="admindailog_title_modal_global_config"
        >
          {dataForEdit.name}
        </DialogTitle>

        <DialogContent
          sx={styleSx.bodyForSupport}
          className="responsive_Support"
        >
          <div className="dropdown_width_outer mt_12">
            <div className="select customized-select">
              <legend>Value</legend>
              <input
                type="number"
                className="text_box_cleartalent custom-text-width-demo-email configaration_input"
                defaultValue={dataForEdit.value}
                min='0'
                onChange={(e) => valueChangeHandler(e.target.value)}

              />
            </div>
          </div>
        </DialogContent>
        <DialogActions sx={styleSx.buttonForSupport}>
          <button
            type="button"
            className="btn5 btn-skill cp"
            onClick={closeEditModalHandler}
          >
            Cancel
          </button>

          <button variant="outlined" className="btn5 btn_primary cp" disabled={atvBtn} onClick={updateConfigarationHandler}>
            <div className="btn_loader">
              Submit
              &nbsp;
              {atvBtn &&
                <div >
                  <CircularProgress size={15} />
                </div>
              }
            </div>
          </button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default SkillTestConfigaration;
